
	import { defineComponent, onMounted, reactive, ref, getCurrentInstance } from 'vue'
	import { supplierOptions, callLineOptions, columns } from './config'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { getAccountList, delCallAccount } from './request'
	import { UsePageDto } from '@/common/mixins/listPageDto'
	import { useStore } from 'vuex'
	import formatDate from '@/common/functions/formatDate'
	import { message, Modal } from 'ant-design-vue'
	import SettingModal from './components/SettingModal.vue'
	import SeatModal from './components/SeatModal.vue'
	import divide from 'library/functions/divide'

	export default defineComponent({
		components: {
			SettingModal,
			SeatModal
		},
		setup() {
			let filter = reactive({
				wayType: null,
				supplierType: null,
				account: ''
			})
			let data = ref([])
			let loading = ref(false)
			const store = useStore()
			let tableData = ref([])
			let authorDate = ref(false)
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const { pagination, listPageDto, handleTableChange, refresh } = UsePageDto(instance)

			const configState = reactive({
				visible: false,
				value: null,
				type: null
			})

			const seatState = reactive({
				visible: false,
				value: null,
				type: null
			})

			const openSetting = (type, row) => {
				Object.assign(configState, {
					visible: true,
					value: row || {},
					type
				})
			}
			const closeConfig = () => {
				Object.assign(configState, {
					visible: false,
					value: null
				})
				fetchList()
			}

			const openSeat = (type, row) => {
				Object.assign(seatState, {
					visible: true,
					value: row,
					type
				})
			}

			const closeSeat = () => {
				Object.assign(seatState, {
					visible: false,
					value: null
				})
				fetchList()
			}

			const delAction = (record) => {
				Modal.confirm({
					content: '确定要删除该条记录吗？',
					onOk() {
						delCallAccount({ num: record.num }).then(() => {
							fetchList()
						})
					}
				})
			}
			// 获取列表
			const fetchList = async () => {
				const params = {
					account: filter.account || null,
					supplierType: filter.supplierType,
					wayType: filter.wayType,
					pageDto: {
						pageNum: listPageDto.pageNum,
						pageSize: listPageDto.pageSize
					}
				}
				loading.value = true
				try {
					const res = await getAccountList(params)
					loading.value = false
					data.value = res.data
					Object.assign(listPageDto, res.pageDto)
				} catch (e) {
					loading.value = false
				}
			}

			onMounted(() => {
				fetchList()
			})
			return {
				openSetting,
				closeConfig,
				configState,
				data,
				store,
				scroll,
				formatDate,
				loading,
				filter,
				fetchList,
				pagination,
				refresh,
				columns,
				supplierOptions,
				handleTableChange,
				divide,
				authorDate,
				callLineOptions,
				openSeat,
				delAction,
				closeSeat,
				seatState
			}
		}
	})
